"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiButton = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
var variants_1 = require("../../../theme/global/variants");
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
exports.MuiButton = {
    root: __assign(__assign({}, typography_1.typography.button), { lineHeight: 'initial', fill: 'currentColor', height: 40, padding: '12px 24px', '&:focus-visible': (_a = {
                backgroundColor: palette_1.palette.grey[300],
                boxShadow: 'none'
            },
            _a["&.".concat(variants_1.Variants.Button.Inverted)] = {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
            _a), '&:hover': (_b = {
                backgroundColor: palette_1.palette.grey[200],
                borderColor: palette_1.palette.common.black
            },
            _b["&.".concat(variants_1.Variants.Button.Inverted)] = {
                borderColor: palette_1.palette.common.white,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '&:active, &$focusVisible': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                },
            },
            _b), '&:active': (_c = {
                backgroundColor: palette_1.palette.grey[300],
                boxShadow: 'none'
            },
            _c["&.".concat(variants_1.Variants.Button.Inverted)] = {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
            _c), '&:disabled': {
            borderColor: palette_1.palette.grey[400],
            color: palette_1.palette.grey[400],
        } }),
    disabled: {},
    focusVisible: {},
    contained: (_d = {
            backgroundColor: palette_1.palette.primary.main,
            boxShadow: 'none',
            color: palette_1.palette.common.white,
            '&$disabled': {
                backgroundColor: palette_1.palette.grey[400],
                color: palette_1.palette.common.white,
            },
            '&:focus-visible': {
                backgroundColor: palette_1.palette.primary.dark,
                boxShadow: 'none',
            },
            '&:hover': {
                backgroundColor: palette_1.palette.primary.light,
                boxShadow: 'none',
                '@media (hover: none)': {
                    backgroundColor: palette_1.palette.primary.main,
                },
            },
            '&:active': {
                backgroundColor: palette_1.palette.primary.dark,
                boxShadow: 'none',
            }
        },
        _d["&.".concat(variants_1.Variants.Button.Brand)] = {
            backgroundColor: palette_1.palette.orange,
            '&$disabled': {
                backgroundColor: palette_1.palette.grey[400],
                color: palette_1.palette.common.white,
            },
            '&:focus-visible': {
                backgroundColor: (0, colorManipulator_1.darken)(palette_1.palette.orange.toString(), 0.4),
                boxShadow: 'none',
            },
            '&:hover': {
                backgroundColor: (0, colorManipulator_1.darken)(palette_1.palette.orange.toString(), 0.05),
                boxShadow: 'none',
                '@media (hover: none)': {
                    backgroundColor: palette_1.palette.primary.main,
                },
            },
            '&:active': {
                backgroundColor: (0, colorManipulator_1.darken)(palette_1.palette.orange.toString(), 0.2),
                boxShadow: 'none',
            },
        },
        _d),
    containedPrimary: {
        backgroundColor: palette_1.palette.success.main,
        '&:focus-visible': {
            backgroundColor: palette_1.palette.success.dark,
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: palette_1.palette.success.light,
            '@media (hover: none)': {
                backgroundColor: palette_1.palette.success.main,
            },
        },
        '&:active': {
            backgroundColor: palette_1.palette.success.dark,
            boxShadow: 'none',
        },
    },
    containedSecondary: {
        backgroundColor: palette_1.palette.error.main,
        '&:focus-visible': {
            boxShadow: 'none',
            backgroundColor: palette_1.palette.error.dark,
        },
        '&:hover': {
            backgroundColor: palette_1.palette.error.light,
            '@media (hover: none)': {
                backgroundColor: palette_1.palette.error.main,
            },
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: palette_1.palette.error.dark,
        },
    },
    iconSizeSmall: {
        '& > svg': {
            height: 16,
            width: 16,
        },
    },
    iconSizeMedium: {
        '& > svg': {
            height: 16,
            width: 16,
        },
    },
    outlined: (_e = {
            borderColor: palette_1.palette.common.black,
            color: palette_1.palette.common.black,
            padding: '12px 24px'
        },
        _e["&.".concat(variants_1.Variants.Button.Inverted)] = {
            color: palette_1.palette.common.white,
            borderColor: palette_1.palette.common.white,
        },
        _e),
    outlinedPrimary: {
        borderColor: palette_1.palette.success.main,
        color: palette_1.palette.success.main,
    },
    outlinedSecondary: {
        borderColor: palette_1.palette.error.main,
        color: palette_1.palette.error.main,
    },
    sizeSmall: {
        fontSize: typography_1.typography.pxToRem(14),
        height: 32,
        padding: '12px 16px',
    },
    text: (_f = {
            color: palette_1.palette.common.black,
            padding: '12px 24px'
        },
        _f["&.".concat(variants_1.Variants.Button.Inverted)] = {
            color: palette_1.palette.common.white,
        },
        _f),
    textPrimary: {
        color: palette_1.palette.success.main,
    },
    textSecondary: {
        color: palette_1.palette.error.main,
    },
};
